var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirecracker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5C11.5858 4.5 11.25 4.16421 11.25 3.75V2.75C11.25 2.33579 11.5858 2 12 2C12.4142 2 12.75 2.33579 12.75 2.75V3.75C12.75 4.16421 12.4142 4.5 12 4.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.25C12.4142 5.25 12.75 5.58579 12.75 6V7H15C16.0161 7 16.8552 7.75775 16.9831 8.73899C13.8118 10.1737 10.4469 11.1277 7 11.5718V9C7 7.89543 7.89543 7 9 7H11.25V6C11.25 5.58579 11.5858 5.25 12 5.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5303 5.28033L15.5303 4.28033C15.8232 3.98744 15.8232 3.51256 15.5303 3.21967C15.2374 2.92678 14.7626 2.92678 14.4697 3.21967L13.4697 4.21967C13.1768 4.51256 13.1768 4.98744 13.4697 5.28033C13.7626 5.57322 14.2374 5.57322 14.5303 5.28033Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46967 3.21967C8.17678 3.51256 8.17678 3.98744 8.46967 4.28033L9.46967 5.28033C9.76256 5.57322 10.2374 5.57322 10.5303 5.28033C10.8232 4.98744 10.8232 4.51256 10.5303 4.21967L9.53033 3.21967C9.23744 2.92678 8.76256 2.92678 8.46967 3.21967Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.5874V16.5619C10.454 16.1096 13.8248 15.1452 17 13.6981V10.915C13.8074 12.2689 10.4411 13.1683 7 13.5874Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18.5781C10.4419 18.152 13.8083 17.2453 17 15.8838V20C17 21.1046 16.1046 22 15 22H9C7.89543 22 7 21.1046 7 20V18.5781Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirecracker);
export default __webpack_public_path__ + "static/media/firecracker.559050977e9503b33fab61634ac884f4.svg";
export { ForwardRef as ReactComponent };